import React, { useEffect, useCallback } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { logOut, setExamPassed, setVideoWatched } from '../app/store'
import axios from 'axios';

const ResultsRecap = () => {

    const { t } = useTranslation();
    const user = useSelector((state)=> state.user)
    const questions = useSelector((state)=> state.questions)
    const dispatch = useDispatch()

    const sendNow = useCallback(async(usr) => {
        const url = process.env.REACT_APP_LOCAL_BACKEND_URL+'save-result';
        const config = {
          headers: {'Authorization': process.env.REACT_APP_LOCAL_BACKEND_TOKEN},
        }
        const data = {
            user: usr
        }
        try {
          await axios.post(url,data,config);
          console.log('INFO: invio risultati ok')
        } catch(error){
            console.log('ERR: invio risultato fallito');
        } 
    },[])
    useEffect(
        ()=>{
            dispatch(setExamPassed(true))
            const usernow = {
                ...user,
                score: user.score,
                exam_passed: true,
            }
            sendNow(usernow)
        },[dispatch,sendNow,user]
    )

    const handleLogout = () => {
        dispatch(logOut())
        dispatch(setVideoWatched(false))
      }


  return (
    <div className='container'>
        <div className='row'>
            <div className='col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 border rounded p-4 login-form'>
                <h3 className='text-center'>{t('congratulazioni')}!</h3>
                <h4 className='text-center'>{t('esame_superato')}</h4>
                <div className='row'>
                    <h5 className='text-center'>{t('esito')}:</h5>
                    <div className='col-12 text-center mt-3'>{t('risposte_corrette')}: {user.score?user.score:t('dato_non_disponibile')} {user.score?'/ '+questions.tot_questions:''}</div>
                    <div className='col-12 text-center mb-3'>{t('punteggio_minimo')}: {questions.min_score_to_pass}</div>
                </div>
                <div className='col-12 text-center mt-3'>
                    <button type='button' className='basf-btn m-0' onClick={()=>{handleLogout()}}>{t('fine')}</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ResultsRecap